import { useMemo } from "react";
import { useUser } from "../../../context/UserContext";

/**
 * True when the current team is a sandbox team.
 *
 * Checks both /me (user.lastTeam.isSandbox) and the JWT claim (team.isSandbox).
 * Either source flagging sandbox is enough to gate — fail-closed protects us
 * if one source drifts (e.g. a backend response forgets to include the field,
 * or an old token lacks it).
 */
export const useIsSandboxTeam = (): boolean => {
    const { user } = useUser();

    const fromMe = Boolean(user?.lastTeam?.isSandbox);

    const fromToken = useMemo(() => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                return false;
            }
            const payload = JSON.parse(atob(token.split(".")[1]).toString());
            return Boolean(payload?.team?.isSandbox);
        } catch (err) {
            console.error("Failed to decode JWT for sandbox check:", err);
            return false;
        }
    }, [user?.lastTeam?.id]);

    return fromMe || fromToken;
};
